import React from 'react';
import { IconXClose } from '@pentabd/icons';
import Text from '../../text/Text';

interface Props {
  onClickDeleteExtensionClose: () => void;
  length: number;
}

function SelectedView({ onClickDeleteExtensionClose, length }: Props) {
  return (
    <div className="d-flex justify-content-between align-items-center bg-primary px-12 py-8 mx-12 my-10 gap-12 rounded-6 flex-wrap">
      <div className="d-flex gap-8 align-items-center">
        <div
          onClick={onClickDeleteExtensionClose}
          className="d-flex align-items-center pointer"
        >
          <IconXClose size="20" fill="white" />
        </div>
        <Text color="white" size="sm" weight="medium">
          {length} Selected
        </Text>
      </div>
    </div>
  );
}

export default SelectedView;
